import { render } from "./User.vue?vue&type=template&id=03ac3d40&scoped=true"
const script = {}

import "./User.vue?vue&type=style&index=0&id=03ac3d40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ac3d40"]])

export default __exports__